import(/* webpackMode: "eager" */ "/var/www/rentzeme/app/src/app/(main)/terms/page.tsx");
